import { render, staticRenderFns } from "./bill-zf-list.vue?vue&type=template&id=e5675322&scoped=true"
import script from "./bill-zf-list.vue?vue&type=script&lang=js"
export * from "./bill-zf-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5675322",
  null
  
)

export default component.exports